<template>
  <div class="width-full bg">
    <div class="max-width mauto bgbox">
      <div class="flex mauto color-white foot">
        <div class="logo">
          <img src="../assets/logo.png" alt="" class="logo">
        </div>
        <div class="foot1">
          <span class="aa" @click="$router.push('/')">首页</span>
          <div class="bb">
            <span @click="$router.push('/about')">为什么选未来视讯</span>
            <span @click="$router.push('/about')">我们的服务</span>
            <span @click="$router.push('/about')">我们的见证</span>
          </div>
          

        </div>
        <!-- <div class="foot1">
          <span class="aa" >校园AI智能平台</span>
          <div class="bb">
            <span >校园AI智能平台</span>
          </div>
          
        </div> -->
        <div class="foot1">
          <span class="aa" @click="$router.push('/allSolo')">AI场景化解决方案</span>
          <div class="bb">
            <span v-for="item in soloList" :key="item.id" @click="toDtl(item)">{{ item.name }}</span>
          </div>
          <!-- <div class="bb">
            <span @click="$router.push('/success1')">视频案例</span>
            <span @click="$router.push('/success2')">图文案例</span>
            <span @click="$router.push('/success3')">设计作品</span>

          </div> -->
          
        </div>
        <div class="foot1">
          <span class="aa" @click="$router.push('/service')">服务资讯</span>
          <div class="bb">
            <span v-for="item in serviceType" :key="item.id" @click="$router.push({path:'/service',query:{classid:item.id}})">{{ item.name }}</span>
          </div>
        </div>
        <div class="foot1">
          <span class="aa" @click="$router.push('/about')">未来视讯科技AI</span>
          <div class="bb">
            <span @click="jumpAbout('about')">关于我们</span>
            <span @click="jumpAbout('honors')">荣誉资质</span>
            <span @click="jumpAbout('team')">优秀团队</span>
            <span @click="$router.push('/rencai')">人才招聘</span>
            <span @click="$router.push('contact')">联系我们</span>

          </div>
          
        </div>
        <!-- <div class="foot1">
          <span class="aa" @click="$router.push('/contact')">联系我们</span>
          <div class="bb">
            <span @click="$router.push('/contact')">寻求合作</span>
          </div>
          
        </div> -->
        <div class="foot1">
          <span class="aa" @click="$router.push('/future')">携手未来</span>
          <div class="bb cc">
            <div class="icon">
              <img src="../assets/wx2.png" alt="" class="wx2">
              <img src="../assets/email2.png" alt="" class="email2">
            </div>
            <span>邮箱</span>
            <span>{{ yx }}</span>
          </div>
          
        </div>
      </div>
    </div>
    <div class="line"></div>
    <div class="max-width mauto bgbox dd">
      <div class="flex flex-col align-center mauto color-white">
        <div class="fs12" style="opacity: 0.8;padding-top: 20px;">Copyright Ⓒ2026 杭州未来视讯科技有限公司版权所有  <span class="pointer" @click="jump1" style="padding-left: 1rem;">{{ beian }}</span>  <span class="pointer" style="padding-left: 1rem;" @click="jump2">技术支持：科辉荣盛</span></div>
      </div>
    </div>
    <div class="ee">
      <div class="">Copyright Ⓒ2026 杭州未来视讯科技有限公司版权所有</div>
      <div class="" style="padding: 3px 0;"><span class="pointer" @click="jump1" style="padding-left: 1rem;">{{ beian }}</span>  <span class="pointer" style="padding-left: 10px;" @click="jump2">技术支持：科辉荣盛</span></div>

       
    </div>
  </div>
</template>
   
<script>
import { jjfw_classs,fwzx_type,config_info } from "../api/home";
import { EventBus } from '../utils/eventBus'

export default {
	data() {
		return {
      info:'',
      soloList:[],
      serviceType:[],
      yx:'',
      beian:'',
		}
	},

  created(){
    this.getSoloType()
    this.getServicetype()
    this.getYx()
  },
  methods: {
    jumpAbout(ids){
      this.$router.push({ path: '/about'});
      setTimeout(()=>{
        EventBus.$emit('scrollTo', ids); 
      },500)

    },
    getYx(){
      config_info({
        type:'email',
      }).then((res) => {
        if (res.code == 1) {
         this.yx = res.data
        }
      });
      config_info({
        type:'beian1',
      }).then((res) => {
        if (res.code == 1) {
         this.beian = res.data
        }
      });
    },
    getServicetype(){
      fwzx_type().then((res) => {
        if (res.code == 1) {
         this.serviceType = res.data
        }
      });
    },
    getSoloType(){
      jjfw_classs({
        index_switch:''
      }).then((res) => {
        if (res.code == 1) {
         this.soloList = res.data
        }
      });
    },
    jump1(){
      window.open('https://beian.miit.gov.cn/');
      // window.location.href = 'https://beian.miit.gov.cn/'
    },
    jump2(){
      window.open('http://www.bjkhrs.com/');
      // window.location.href = 'http://www.bjkhrs.com/'
    },
    toDtl(item){
      this.$router.push({path:'/soloDtl',query:{id:item.id}})
      setTimeout(()=>{
        window.location.reload()
      },500)
    }
  },
}
</script>

<style scoped lang="scss">
.bg{
  height: 650px;
  background-image: url('https://oozstar.oss-ap-northeast-1.aliyuncs.com/index/baoxiu/footer.png');
  background-size: cover;
}
.line{
  width: 100%;
  height: 1px;
  background: rgba(255, 255, 255, 0.50);
  margin-top: 120px;
}
.logo{
  width: 110px;
  height: 90px;
}
.foot{
  display: flex;
  justify-content: space-between;
  padding-top: 200px;
}
.foot1{
  height: 250px;
  display: flex;
  flex-direction: column;
  font-size: 15px;
  span{
    padding-top: 15px;
    cursor: pointer;
  }
  .aa{
    font-size: 18px;
  }
  .bb{
    display: flex;
    flex-direction: column;
  }
}
.icon{
  margin-top: 15px;
  .wx2{
    width: 27px;
    height: 27px;
  }
  .email2{
    width: 27px;
    height: 27px;
    margin-left: 10px;
  }
}
//mobile
@media (max-width: 1200px) {
  .bg{
    height: auto;
    .bgbox{
      width: 100%;
      .foot{
        width: 90%;
        margin-left: 5%;
        display: flex;
        flex-direction: column;
        padding-top: 30px;

        .logo{
          width: 70px;
          height: 53px;
          margin: auto;
        }
        .foot1{
           height: auto;
           margin-top: 20px;

          .aa{
            font-size: 17px;
          }
          .bb{
            opacity: 0.9;
            width: 100%;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            span{
              width: 30%;
              margin-right: 5%;
            }
            span:nth-child(3n){
              margin-right: 0;
            }
          }
          .cc{
            display: flex;
            flex-direction: column;
          }
        }
       
      }
    }
  }
   .line{
      margin-top: 35px;
    }
    .dd{
      display: none;
    }
    .ee{
      color: #fff;
      font-size: 10px;
      opacity: 0.9;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 20px;
      padding-bottom: 20px;
    }
}
//pc
@media (min-width: 1201px) {
  .ee{
    display: none;
  }
}


</style>